import { DataAnalyticsService } from './../../services/data-analytics.service';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import moment from 'moment';
import { DataService } from 'src/app/shared/service/data.service';
import { WasteDashboardModel } from 'src/app/features/waste-dashboard/model/waste-dashboard-model.model';
import { SaveTagComponent } from '../save-tag/save-tag.component';
import { MatDialog } from '@angular/material/dialog';
import { SaveTagPopupComponent } from '../save-tag-popup/save-tag-popup.component';
import { Router } from '@angular/router';
import { BookMarkList, FactorySummary, FactorySummaryDetails } from '../../models/factory-summary';
// import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { Usagereport } from 'src/app/shared/handlers/usagereport';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service.service';
import { MsalService } from '@azure/msal-angular';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-da-header',
  templateUrl: './da-header.component.html',
  styleUrls: ['./da-header.component.scss'],
  providers: [DatePipe]
})
export class DaHeaderComponent implements OnInit, OnDestroy {
  @Input() factoryName: string;
  @Input() insightLevel: string;
  @Input() lineName: string;
  @Input() showCommentBox: boolean;
  @Input() currentDate: string;
  @Input() currrentFilter: string;
  @Input() filterApplied: boolean;
  @Input() isCurrentURLSaved: boolean;
  @Input() bookmarkList: BookMarkList[];
  @Output() applyFilter = new EventEmitter<any>();
  @Output() toggleComment = new EventEmitter<boolean>();
  @Input() factorySummary: FactorySummaryDetails;

  timeText: any;
  showTimePickerStatus: any = false;
  enableApplyBtn: boolean;
  typeOfFilter: any;
  today: Date = new Date();
  appliedHour: any;
  appliedShift: any;
  appliedEndWeek: any;
  appliedYear: any;
  appliedQuarterFrom: any;
  appliedQuarterTo: any;
  currentHour: any;
  currentEndWeek: any;
  emitDataList: any;
  userDtls: any;
  subscription: Subscription;
  level: string;
  startTime: Date;
  bookMarkSubscription: Subscription;

  constructor(
    private dataService: DataService,
    public dialog: MatDialog,
    private daService: DataAnalyticsService,
    public auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private usageReport: Usagereport,
    public authService: MsalService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.startTime = new Date();
    this.subscription = this.route.queryParams.subscribe(params => {
      if (params.level && params.factory) {
        // check if not empty
        this.getBookmarkData();
      }
      if (params && params.commentId && params.commentId !== '') {
        this.toggleCommentBox();
      }
    });

    const selectedHourDetail = {};
    this.currentEndWeek = '';

    const startOfMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    const endOfMonth = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');

    this.emitDataList = {
      appliedFilterType: this.currrentFilter,
      dateObj: new Date(this.currentDate),
      selectedHr: selectedHourDetail,
      endWeekFromSelectedDate: this.currentEndWeek,
      startOfMonth,
      endOfMonth,
      startQuarterMonth: null
    };
    this.dataService.setStorageData('selectedDATimeFilter', JSON.stringify(this.emitDataList));
    this.dataService.setStorageData('selectedPeriod', this.currrentFilter);
    if (this.auth.checkIsAuthticated) {
      this.userDtls = this.authService.getAccount();
    }

    this.dataService.removeBookmark$.subscribe((data => {
      this.isCurrentURLSaved = false;
    }));
  }

  getFormattedDate(): string {
    if (!this.filterApplied || !this.currrentFilter) return '';

    const translate = (value: string) => value; // Replace with actual translate if needed

    const format = (date: Date | string | number, formatStr: string) =>
      this.datePipe.transform(date, formatStr);

    switch (this.currrentFilter) {
      case 'quarter': {
        const [start, end] = this.currentDate?.split('|') ?? [];
        return `${translate(format(start, 'MMM'))} - ${translate(format(end, 'MMM'))} ${format(start, 'yyyy')}`;
      }
      case 'date': {
        return `${format(this.currentDate, 'dd')}/${translate(format(this.currentDate, 'MMM'))}/${format(this.currentDate, 'yyyy')}`;
      }
      case 'year': {
        return format(this.currentDate, 'yyyy')!;
      }
      case 'month': {
        return `${translate(format(this.currentDate, 'MMMM'))} ${format(this.currentDate, 'yyyy')}`;
      }
      case 'week': {
        const start = this.currentDate;
        const end = this.currentEndWeek - 1;
        return `${format(start, 'dd')}/${translate(format(start, 'MMM'))}/${format(start, 'yyyy')} - ${format(end, 'dd')}/${translate(format(end, 'MMM'))}/${format(end, 'yyyy')}`;
      }
      case 'hour': {
        return `${format(this.currentDate, 'dd')}/${translate(format(this.currentDate, 'MMM'))}/${format(this.currentDate, 'yyyy')}, ${this.currentHour}`;
      }
      default:
        return '';
    }
  }

  onClickLine() {

    this.usageReport.report('Insight Dashboard - Line', this.startTime, this.factorySummary.clusterName,
      this.factorySummary.factoryName, this.lineName, null);

    if (this.insightLevel === 'line') {
      const queryParamsData: any = {
        cluster: this.factorySummary.clusterId,
        factory: this.factorySummary.factoryId,
        FromDate: this.factorySummary.fromDate,
        ToDate: this.factorySummary.toDate,
        level: (this.level) ? this.level : 'factory',
      };
      if (this.level === 'factory') {
        queryParamsData.level = 'line';
        queryParamsData.LineId = null;
      }
      this.router.navigate([],
        {
          relativeTo: this.route,
          queryParams: queryParamsData,
          // queryParamsHandling: 'merge', // remove to replace all query params by provided
        }
      );
    }
  }

  showHideTimeStatus(value: string) {
    if (value === 'ok') {
      this.filterApplied = true;
      this.currrentFilter = this.typeOfFilter;
      this.currentDate = this.timeText;
      this.currentHour = this.appliedHour.label;
      this.currentEndWeek = this.appliedEndWeek;

      this.emitDataList = {
        appliedFilterType: this.currrentFilter,
        dateObj: this.currentDate,
        selectedHr: this.appliedHour,
        endWeekFromSelectedDate: this.currentEndWeek,
        startOfMonth: moment(this.currentDate).startOf('month').format('YYYY-MM-DD'),
        endOfMonth: moment(this.currentDate).endOf('month').format('YYYY-MM-DD')
      };

      if (this.currrentFilter === 'year') {
        this.emitDataList.startOfMonth = this.appliedYear + '-01-01';
        const currYear = new Date().getFullYear();
        if (currYear === this.appliedYear) {
          const yesterday = new Date();
          const currentYearDate = new Date(yesterday.getFullYear(), yesterday.getMonth(), 0);
          const emitCurrentYearEndDate = currentYearDate.getDate();
          yesterday.setDate(yesterday.getDate());
          this.emitDataList.endOfMonth = this.appliedYear + '-' + (yesterday.getMonth()) + '-' + emitCurrentYearEndDate;
        } else {
          this.emitDataList.endOfMonth = this.appliedYear + '-12-31';
        }
      }

      if (this.currrentFilter === 'quarter') {
        this.emitDataList.startOfMonth = this.appliedQuarterFrom;
        this.emitDataList.endOfMonth = this.appliedQuarterTo;
        this.emitDataList.startQuarterMonth = new Date(this.emitDataList.startOfMonth);
        this.emitDataList.endQuarterMonth = new Date(this.emitDataList.endOfMonth);
        this.currentDate = this.emitDataList.startQuarterMonth + '|' + this.emitDataList.endQuarterMonth;
      }

      if (this.currrentFilter === 'month') {
        const prevMonth = moment(this.currentDate).format('M');
        const currMonth = moment().format('M');
        if (prevMonth === currMonth) {
          // this.emitDataList.endOfMonth = moment().subtract(1, 'days').format('YYYY-MM-DD');
          this.emitDataList.endOfMonth = moment(this.currentDate).endOf('month').format('YYYY-MM-DD');
        }
      }

      if (this.currrentFilter !== 'week') {
        this.emitDataList.endWeekFromSelectedDate = '';
      }

      this.dataService.setStorageData('selectedDATimeFilter', JSON.stringify(this.emitDataList));
      this.dataService.setStorageData('selectedPeriod', this.currrentFilter);
      this.isCurrentURLSaved = false;
      this.applyFilter.emit(this.emitDataList);
    }

    this.showTimePickerStatus = !this.showTimePickerStatus;
  }


  appliedFiltersList(eventFilterData) {
    this.enableApplyBtn = false;

    if (eventFilterData.typeOfFilter !== 'filter-changed') {
      this.enableApplyBtn = true;
    }

    this.typeOfFilter = eventFilterData.typeOfFilter;
    this.appliedShift = eventFilterData.shift;
    this.appliedHour = eventFilterData.hour;
    this.appliedYear = eventFilterData.year;
    this.appliedQuarterFrom = eventFilterData.startDate;
    this.appliedQuarterTo = eventFilterData.endDate;

    if (eventFilterData.typeOfFilter !== 'month') {
      if (eventFilterData.typeOfFilter === 'year') {
        this.timeText = new Date(eventFilterData.year, 0, 1);
      } else {
        this.appliedEndWeek = new Date(eventFilterData.year, eventFilterData.month, (eventFilterData.date + 7));
        this.timeText = new Date(eventFilterData.year, eventFilterData.month, eventFilterData.date);
      }
    } else {
      this.timeText = new Date(eventFilterData.year, eventFilterData.month);
    }
  }

  openSaveTag() {
    try {
      const dialogRef = this.dialog.open(SaveTagPopupComponent, {
        width: '400px',
        height: '250px',
        disableClose: true,
        data: {
          isSaved: !this.isCurrentURLSaved,
          name: this.insightLevel === 'factory' ? this.factoryName + ' - Factory' : this.lineName + ' - Line',
          filterType: this.currrentFilter,
          currDate: this.currentDate,
          id: this.bookmarkList.filter(data => data.url === window.location.href)[0] ?
            this.bookmarkList.filter(data => data.url === window.location.href)[0].id : ''
        }
      });

      dialogRef.afterClosed().subscribe(data => {

        if (data === 'save') {
          this.isCurrentURLSaved = true;
          this.getBookmarkData();
        } else if (data === 'delete') {
          this.isCurrentURLSaved = false;
        }
      });

    } catch (error) {

    }
  }

  getBookmarkData() {
    try {
      this.bookmarkList = [];
      this.isCurrentURLSaved = false;
      if (this.auth.checkIsAuthticated) {
        this.userDtls = this.authService.getAccount();
      }
      this.bookMarkSubscription = this.daService.getBookmark({ createdby: this.userDtls.userName })
        .subscribe((data) => {

          if (data && data.length > 0) {
            this.bookmarkList = data;
            const routerIndex = this.bookmarkList.map(list => list.url).indexOf(window.location.href);
            if (routerIndex > -1) {
              this.isCurrentURLSaved = true;
            } else {
              this.isCurrentURLSaved = false;
            }
          }
        }, err => {

        });
    } catch (error) {

    }
  }

  toggleCommentBox() {
    this.showCommentBox = !this.showCommentBox;
    this.toggleComment.emit(this.showCommentBox);
    this.daService.toggleChatBox(this.showCommentBox);
  }


  ngOnDestroy(): void {
    if (this.bookMarkSubscription) {
      this.bookMarkSubscription.unsubscribe();
    }
  }
}
